<ng-container *t="let t">
  <div class="home-container">
    <div class="supplier-details">
      <div class="column w-100">
        <div class="header-title-container">
          <h3 *ngIf="!['entityExtension', 'nameOrTINChange', 'reactivation'].includes(onboardingType)"
            i18n="@@SupplierOnboarding" t="SupplierOnboarding">Supplier Onboarding</h3>
          <h3 *ngIf="onboardingType == 'reactivation'" i18n="@@SupplierReactivation" t="SupplierReactivation">Supplier
            Reactivation</h3>
          <h3 *ngIf="['entityExtension'].includes(onboardingType)" i18n="@@SupplierEntityExtension"
            t="SupplierEntityExtension">Validation for Tesla Business and Payable Location</h3>
          <h3 *ngIf="['nameOrTINChange'].includes(onboardingType)" i18n="@@SupplierNameTinChange"
            t="SupplierNameTinChange">Update to Your Organization's Legal Name or Tax ID Number</h3>
          <button tsl-button ghost *ngIf="allowToRerouteToPostOnboarding" (click)="navigateToDetail()"
            i18n="@@BACKTOYOURSUPPLIERPROFILE" t="BACKTOYOURSUPPLIERPROFILE">BACK TO YOUR SUPPLIER PROFILE</button>
        </div>
        <span class="supplier-name" [hidden]="!supplierCode">{{ supplierName }}<span *ngIf="supplierName"> - </span>{{
          supplierCode }}</span>
      </div>

      <div class="column">
        <app-details class="details" [tsl-showAdditionalDetailsLink]="false"
          (tsl-supplierCodeChanged)="supplierCodeChangeEventHandler($event.selectedSupplierCode)">
        </app-details>
      </div>
    </div>
    <br />
    <div class="body-container">
      <div class="section">
        <tsl-onboarding-training [isHomePage]="true" [tsl-entityCountry]="entityCountry"
          [tsl-onboardingType]="onboardingType" [supplierCode]="supplierCode">
        </tsl-onboarding-training>
      </div>
      <br />
      <div class="task-help-container">
        <div *ngIf="tasksByRequest.length > 0" class="task-list-container">
          <div *ngFor="let item of tasksByRequest | sortBy: 'asc' : 'order'" class="section task-dashboard-container">
            <tsl-accordion [hideDivider]="true">
              <tsl-accordion-group [expanded]="true">
                <tsl-accordion-header>
                  <div class="tasks-title">
                    <h3 *ngIf="['TPRM'].includes(item?.requestType)" i18n="@@yourTPRMTasks" t="yourTPRMTasks">
                      Cyber
                      Third-Party Risk Management Tasks</h3>
                    <h3 *ngIf="['RRT'].includes(item?.requestType)" i18n="@@yourRRTTasks" t="yourRRTTasks">
                      Risk Treatment Tasks</h3>
                    <h3 *ngIf="!['reactivation', 'entityExtension', 'nameOrTINChange'].includes(onboardingType)
                        && !['TPRM', 'RRT'].includes(item?.requestType)" i18n="@@yourOnboardingTasks"
                      t="yourOnboardingTasks">Your Onboarding Tasks</h3>
                    <h3 *ngIf="onboardingType == 'reactivation'" i18n="@@yourReactivationOnboardingTasks"
                      t="yourReactivationOnboardingTasks">Your Reactivation Tasks</h3>
                    <h3 *ngIf="['entityExtension', 'nameOrTINChange'].includes(onboardingType)"
                      i18n="@@yourAssignedTasks" t="yourAssignedTasks">Your Assigned Tasks</h3>
                    <div class="count">
                      {{ item?.tasks?.length || 0 }}
                    </div>
                    <tsl-icon class="manual-link" [disabled]="!isloaded" (click)="refreshTaskBoard()">refresh</tsl-icon>
                    <button class="view-tasks" i18n="@@viewAllTasks" t="viewAllTasks" tsl-button ghost size="medium"
                      (click)="openSRMTask()">VIEW
                      ALL TASKS</button>
                  </div>
                </tsl-accordion-header>
                <div *ngIf="item?.tasks?.length > 0">
                  <tsl-alert *ngIf="['TPRM', 'RRT'].includes(item?.requestType)" status="warning"
                    i18n="@@TPRMSectionMessage" t="TPRMSectionMessage" class="spacing">
                    Complete the following questionnaires regarding your organization’s information security,
                    compliance, data privacy or product security management. These questionnaires are not required to
                    complete financial
                    onboarding with Tesla but require completion to meet Supplier policy obligations related to Tesla
                    cyber third-party risk management.
                  </tsl-alert>
                  <tsl-alert *ngIf="getProgress(item?.tasks) == 100 && isUnderReview(item);" status="success"
                    i18n="@@OnboardingTaskAllCompletedMessage" t="OnboardingTaskAllCompletedMessage" class="spacing">
                    Thank you for completing all assigned tasks which have been sent to Tesla for review. Further
                    details,
                    need for corrective action, or approval notes will be sent to you via email communication.
                  </tsl-alert>

                  <tsl-progress-bar class="space-bottom" status="success" [value]="getProgress(item?.tasks)">
                    <span i18n="@@yourProgressTowardsCompletion" t="yourProgressTowardsCompletion">
                      Your progress towards completion
                    </span> ({{getProgress(item?.tasks)}}%)
                  </tsl-progress-bar>
                </div>
                <br />
                <div *ngIf="(isloaded && item?.tasks?.length == 0); else showTasks">
                  <tsl-label i18n="@@noPendingTasks" t="noPendingTasks">
                    No pending tasks.
                  </tsl-label>
                </div>
                <ng-template #showTasks>
                  <div *ngFor="let task of item?.tasks | sortBy: 'asc' : 'order'" class="list">
                    <div class="task-wrapper" #completedetailstaskmessage1
                      tooltip="Please review and confirm your Supplier Details in order to access this task."
                      i18n-tooltip="@@completedetailstaskmessage"
                      tslTooltip="{{t('completedetailstaskmessage', completedetailstaskmessage1)}}"
                      [tslTooltipDisabled]="!task.disabled" tslTooltipPosition="top">
                      <div class="task-status">
                        <tsl-chip [disabled]="task.disabled" (click)="openTaskSideNavWithRouting(task)"
                          [ngClass]="task.disabled ? '' : statusClass[task.taskStatus]"
                          *ngIf="getProgress(item?.tasks) != 100; else onboardingCompletedStatus">
                          {{ translate.get(statusDisplay[task.taskStatus]) }}</tsl-chip>
                        <ng-template #onboardingCompletedStatus>
                          <tsl-chip *ngIf="isUnderReview(item); else showOriginalStatus" [disabled]="task.disabled"
                            (click)="openTaskSideNavWithRouting(task)" [ngClass]="statusClass[task.taskStatus]">
                            {{ translate.get(statusDisplay['Under Tesla Review']) }}</tsl-chip>
                          <ng-template #showOriginalStatus>
                            <tsl-chip [disabled]="task.disabled" (click)="openTaskSideNavWithRouting(task)"
                              [ngClass]="statusClass[task.taskStatus]">
                              {{ translate.get(statusDisplay[task.taskStatus]) }}</tsl-chip>
                          </ng-template>
                        </ng-template>
                      </div>
                      <div class="task-detail-container">
                        <div [tslTooltipDisabled]="!task.disabled" tslTooltipPosition="after"
                          [ngClass]="task.disabled ? 'task-detail-disabled' : 'task-detail'" [disabled]="task.disabled"
                          (click)="openTaskSideNavWithRouting(task)">
                          <ng-container *ngIf="task?.taskRequestMetadata?.documentType; else title">
                            {{ translate.get(task?.titleI18nKey) == task?.titleI18nKey ? task?.title :
                            translate.get(task?.titleI18nKey) }} - {{task?.taskRequestMetadata?.documentDescription ?
                            translate.get(task.taskRequestMetadata.documentDescription) :
                            (task?.taskRequestMetadata?.documentType ?
                            translate.get(task.taskRequestMetadata.documentType)
                            :
                            '')}}
                          </ng-container>
                          <ng-template #title>
                            {{ translate.get(task?.titleI18nKey) == task?.titleI18nKey ? task?.title :
                            translate.get(task?.titleI18nKey) }}
                          </ng-template>
                        </div>
                        <p class="task-description">
                          {{ translate.get(task?.descriptionI18nKey) == task?.descriptionI18nKey ? task?.description :
                          translate?.get(task.descriptionI18nKey) }}
                        </p>
                      </div>
                      <div class="task-due"><span i18n="@@due" t="due">Due</span> {{(task?.dueDate || task?.taskRequestMetadata?.dueDate) |
                        date: longDate :(language == "no-NO" ? "nn" : language)}}</div>
                    </div>
                  </div>
                </ng-template>
                <br />

              </tsl-accordion-group>
            </tsl-accordion>
          </div>
        </div>
        <div class="section help-document-container">
          <div class="help-document-header-container">
            <h3 class="mb-3 header"><span i18n="@@HelpContactResources" t="HelpContactResources">Help & Contact Resources</span>
            </h3>
          </div>

          <div>
            <ng-container [ngSwitch]="onboardingType">
              <ul *ngSwitchCase="['initial','subTier'].includes(onboardingType) ? onboardingType : !onboardingType">
                <li *ngIf="isShowFAQ">
                  <span><b i18n="@@faqNew" t="faqNew">Frequently Asked Questions and Queries</b></span>
                  <br/><a i18n="@@clickHere" t="clickHere" class="link" (click)="showDocument('FAQ')">Click Here</a>
                </li>
                <br/>
                <li *ngIf="isShowManual">
                  <span><b i18n="@@Instructions" t="Instructions">Instructions</b></span>
                  <br/> <a i18n="@@clickHere" t="clickHere" class="link" (click)="showDocument('Manual')">Click Here</a>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@SubTierInitialInquiries" t="SubTierInitialInquiries">SubTier Supplier and Initial Onboarding and Data Inquiries</b><br/><span i18n="@@SubTierInitialInquiriesEmail" t="SubTierInitialInquiriesEmail">Contact your Tesla business contact or Global Supply Manager</span>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaContractAndAggrements" t="TeslaContractAndAggrements">Tesla Contracts or Agreements</b> <br/> <span i18n="@@TeslaContractAndAggrementsEmail" t="TeslaContractAndAggrementsEmail">Contact your Tesla business contact or Global Supply Manager</span>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaCodeOfConduct" t="TeslaCodeOfConduct">Tesla Supplier Code of Conduct</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaCodeOfConductEmail" t="TeslaCodeOfConductEmail" href="mailto:Compliance@tesla.com">Tesla Compliance Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaPrivacyPolicy" t="TeslaPrivacyPolicy">Tesla's Privacy Policies</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaPrivacyPolicyEmail" t="TeslaPrivacyPolicyEmail" href="mailto:Privacy@tesla.com">Tesla Privacy Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaDataClassificationManagementPolicy" t="TeslaDataClassificationManagementPolicy">Tesla Data Classification and Management Policy</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaDataClassificationManagementPolicyEmail" t="TeslaDataClassificationManagementPolicyEmail" href="mailto:Infosec@tesla.com">Tesla Information Security Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaEHSOnboarding" t="TeslaEHSOnboarding">Environmental Health and Safety Details and Subcontractor Onboarding</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaEHSOnboardingEmail" t="TeslaEHSOnboardingEmail" href="mailto:contractorsafety@tesla.com">Tesla Contractor Safety Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaDiveristyDetails" t="TeslaDiveristyDetails">Diversity Detail Inquiries</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaDiveristyDetailsEmail" t="TeslaDiveristyDetailsEmail" href="mailto:supplierdiversity@tesla.com">Tesla Supplier Diversity Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@CTPRMSupportNew" t="CTPRMSupportNew">Tesla Cyber Third-Party Risk Management Detail Inquiries</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@CTPRMSupportNewEmail" t="CTPRMSupportNewEmail" href="mailto:ctprm_assessment@tesla.com">Tesla Third-Party Risk Management Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@HomeTabHelpSupportNew" t="HomeTabHelpSupportNew">Technical Troubleshooting Inquiries and Assistance</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@HomeTabHelpSupportNewEmail" t="HomeTabHelpSupportNewEmail" href="mailto:Supplierportal@tesla.com">Tesla Supplier Portal Team</a>.</span>
                </li>
                <br/>
              </ul>
              <ul
                *ngSwitchCase="['extended', 'reactivation', 'entityExtension', 'nameOrTINChange'].includes(onboardingType) ? onboardingType : !onboardingType">
                <li *ngIf="isShowFAQ">
                  <span><b i18n="@@faqNew" t="faqNew">Frequently Asked Questions and Queries</b></span>
                  <br/> <a i18n="@@clickHere" t="clickHere" class="link" (click)="showDocument('FAQ')">Click Here</a>
                </li>
                <br/>
                <li *ngIf="isShowManual">
                  <span><b i18n="@@Instructions" t="Instructions">Instructions</b></span>
                  <br/> <a i18n="@@clickHere" t="clickHere" class="link" (click)="showDocument('Manual')">Click Here</a>
                </li>
                <br/>
                <li>
                  <span><b i18n="@@HomeTabHelpNew" t="HomeTabHelpNew">Tesla Supplier Onboarding and Data inquiries</b></span>
                  <br/> <span i18n="@@contactVendorChanges" t="contactVendorChanges">Contact the Vendor Changes Team at the following resources:</span>
                  <br/> 
                  <ul>
                    <li>
                      &nbsp;<span i18n="@@globalTeamRegions" t="globalTeamRegions">EMEA/NA/SA:</span>&nbsp;<a class="link" i18n="@@HomeTabHelpNewEmail" t="HomeTabHelpNewEmail" href="mailto:Vendorchanges@tesla.com">Tesla Vendor Changes Team</a>
                    </li>
                    <li>
                      &nbsp;<span i18n="@@apacTeamRegions" t="apacTeamRegions">APAC/CN:</span>&nbsp;<a class="link" i18n="@@VendorchangesapacEmail" t="VendorchangesapacEmail"  href="mailto:Vendorchangesapac@tesla.com">Tesla Vendor Changes APAC Team</a>
                    </li>
                  </ul>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@SubTierInitialInquiries" t="SubTierInitialInquiries">SubTier Supplier and Initial Onboarding and Data Inquiries</b> <br/> <span i18n="@@SubTierInitialInquiriesEmail" t="SubTierInitialInquiriesEmail">Contact your Tesla business contact or Global Supply Manager</span>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaContractAndAggrements" t="TeslaContractAndAggrements">Tesla Contracts or Agreements</b> <br/> <span i18n="@@TeslaContractAndAggrementsEmail" t="TeslaContractAndAggrementsEmail">Contact your Tesla business contact or Global Supply Manager</span>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaCodeOfConduct" t="TeslaCodeOfConduct">Tesla Supplier Code of Conduct</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaCodeOfConductEmail" t="TeslaCodeOfConductEmail" href="mailto:Compliance@tesla.com">Tesla Compliance Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaPrivacyPolicy" t="TeslaPrivacyPolicy">Tesla’s Privacy Policies</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaPrivacyPolicyEmail" t="TeslaPrivacyPolicyEmail" href="mailto:Privacy@tesla.com">Tesla Privacy Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaDataClassificationManagementPolicy" t="TeslaDataClassificationManagementPolicy">Tesla Data Classification and Management Policy</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaDataClassificationManagementPolicyEmail" t="TeslaDataClassificationManagementPolicyEmail" href="mailto:Infosec@tesla.com">Tesla Information Security Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaNoPoNoPayPolicy" t="TeslaNoPoNoPayPolicy">Tesla No Purchase Order No Pay Policy</b>
                    <br/><span i18n="@@TeslaNoPoNoPayPolicyVerb" t="TeslaNoPoNoPayPolicyVerb">Contact the Tesla Purchasing Team at the following email addresses:</span>
                    <br/> <span i18n="@@TeslaNoPoNoPayPolicyAPAC" t="TeslaNoPoNoPayPolicyAPAC">APAC</span>: <a class="link" i18n="@@TeslaNoPoNoPayPolicyAPACEmail" t="TeslaNoPoNoPayPolicyAPACEmail"href="mailto:APAC_Purchasing@tesla.com">APAC Purchasing Team</a>
                    <br/> <span i18n="@@TeslaNoPoNoPayPolicyEMEA" t="TeslaNoPoNoPayPolicyEMEA">EMEA</span>: <a class="link" i18n="@@TeslaNoPoNoPayPolicyEMEAEmail" t="TeslaNoPoNoPayPolicyEMEAEmail" href="mailto:EUPurchasing@tesla.com">EMEA Purchasing Team</a>
                    <br/> <span i18n="@@TeslaNoPoNoPayPolicyNA" t="TeslaNoPoNoPayPolicyNA">NA</span>: <a class="link" i18n="@@TeslaNoPoNoPayPolicyNAEmail" t="TeslaNoPoNoPayPolicyNAEmail" href="mailto:IndirectPurchasing@tesla.com">NA Purchasing Team</a>
                  </span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaEHSOnboarding" t="TeslaEHSOnboarding">Environmental Health and Safety Details and Subcontractor Onboarding</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaEHSOnboardingEmail" t="TeslaEHSOnboardingEmail" href="mailto:contractorsafety@tesla.com">Tesla Contractor Safety Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@TeslaDiveristyDetails" t="TeslaDiveristyDetails">Diversity Detail Inquiries</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@TeslaDiveristyDetailsEmail" t="TeslaDiveristyDetailsEmail" href="mailto:supplierdiversity@tesla.com">Tesla Supplier Diversity Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@CTPRMSupportNew" t="CTPRMSupportNew">Tesla Cyber Third-Party Risk Management Detail Inquiries</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@CTPRMSupportNewEmail" t="CTPRMSupportNewEmail" href="mailto:ctprm_assessment@tesla.com">Tesla Third-Party Risk Management Team</a>.</span>
                </li>
                <br/>
                <li>
                  <span> <b i18n="@@HomeTabHelpSupportNew" t="HomeTabHelpSupportNew">Technical Troubleshooting Inquiries and Assistance</b> <br/> <span i18n="@@ContactTheVerbiage" t="ContactTheVerbiage">Contact the</span>&nbsp;<a class="link" i18n="@@HomeTabHelpSupportNewEmail" t="HomeTabHelpSupportNewEmail" href="mailto:Supplierportal@tesla.com">Tesla Supplier Portal Team</a>.</span>
                </li>
              </ul>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>